import styled from 'styled-components'
import classNames from '../classNames'

const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 78px;
  z-index: 1;
  cursor: pointer;
  user-select: none;

  &.${classNames.navigationButtonDisabled} {
    display: none;
  }
`

export default ButtonWrapper
